export default "__VITE_ASSET__00e9h5OG__"